import bmw from '../assets/logos/bmw-logo.png'
import audi from '../assets/logos/audi-logo.png'
import audisport from '../assets/logos/audi-sport-logo.png'
import bmwm from '../assets/logos/bmw-m-logo.png'
import eicher from '../assets/logos/eicher-logo.png'
import ford from '../assets/logos/ford-logo.png'
import hino from '../assets/logos/hino-logo.png'
import honda from '../assets/logos/honda-logo.png'
import infiniti from '../assets/logos/infiniti-logo.png'
import isuzu from '../assets/logos/isuzu-logo.png'
import jeep from '../assets/logos/jeep-logo.png'
import landrover from '../assets/logos/land-rover-logo.png'
import lexus from '../assets/logos/lexus-logo.png'
import mazda from '../assets/logos/mazda-logo.png'
import mercedes from '../assets/logos/mercedes-benz-logo.png'
import mercedesamg from '../assets/logos/mercedes-amg-logo.png'
import mg from '../assets/logos/mg-logo.png'
import nissan from '../assets/logos/nissan-logo.png'
import subaru from '../assets/logos/subaru-logo.png'
import toyota from '../assets/logos/toyota-logo.png'
import toyotacrown from '../assets/logos/toyota-crown-logo.png'
import volkswagen from '../assets/logos/volkswagen-logo.png'
import volvo from '../assets/logos/volvo-logo.png'

const logos = [
    { name: 'BMW', image: bmw },
    { name: 'Audi', image: audi },
    { name: 'Audi Sport', image: audisport },
    { name: 'BMW M', image: bmwm },
    { name: 'Eicher', image: eicher },
    { name: 'Ford', image: ford },
    { name: 'Hino', image: hino },
    { name: 'Honda', image: honda },
    { name: 'Infiniti', image: infiniti },
    { name: 'Isuzu', image: isuzu },
    { name: 'Jeep', image: jeep },
    { name: 'Land Rover', image: landrover },
    { name: 'Lexus', image: lexus },
    { name: 'Mazda', image: mazda },
    { name: 'Mercedes-Benz', image: mercedes },
    { name: 'Mercedes-AMG', image: mercedesamg },
    { name: 'MG', image: mg },
    { name: 'Nissan', image: nissan },
    { name: 'Subaru', image: subaru },
    { name: 'Toyota', image: toyota },
    { name: 'Toyota Crown', image: toyotacrown },
    { name: 'Volkswagen', image: volkswagen },
    { name: 'Volvo', image: volvo },
]

export default function CarLogosCarousel() {
    return (
        <section className="bg-white overflow-hidden">
            <div className="max-w-9xl mx-auto px-6 lg:px-8">
                <div className="relative overflow-hidden">

                    {/* Left fade */}
                    <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" />

                    {/* Right fade */}
                    <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" />

                    <div className="flex w-max animate-logo-scroll">

                        {/* First set */}
                        {logos.map((logo, index) => (
                            <div
                                key={`first-${index}`}
                                className="flex-shrink-0 w-36 h-28 mx-3 flex items-center justify-center"
                            >
                                <img
                                    src={logo.image}
                                    alt={logo.name}
                                    className="max-w-[90px] max-h-[65px] object-contain   hover:grayscale-0 hover:opacity-100 transition-all duration-1000"
                                />
                            </div>
                        ))}

                        {/* Duplicate set for seamless loop */}
                        {logos.map((logo, index) => (
                            <div
                                key={`second-${index}`}
                                className="flex-shrink-0 w-36 h-28 mx-3 flex items-center justify-center"
                            >
                                <img
                                    src={logo.image}
                                    alt={logo.name}
                                    className="max-w-[90px] max-h-[65px] object-contain hover:grayscale-0 hover:opacity-100 transition-all duration-1000"
                                />
                            </div>
                        ))}

                    </div>
                </div>
            </div>

            <style>{`
                @keyframes logo-scroll {
                    from {
                        transform: translateX(0);
                    }

                    to {
                        transform: translateX(-50%);
                    }
                }

                .animate-logo-scroll {
                    animation: logo-scroll 100s linear infinite;
                }

                .animate-logo-scroll:hover {
                    animation-play-state: paused;
                }
            `}</style>
        </section>
    )
}